// extracted by mini-css-extract-plugin
export var archives = "list-module--archives--d77ff";
export var horizon = "list-module--horizon--2a434";